import Dto from '~/base/Dto';
import { modelFactory } from '~/base/ModelFactory';

import AuthApiRepository from './AuthApiRepository';
import { SignInDto } from './dto/SignInDto';
import { SignInForm } from './forms/SignInForm';
import { AuthAccessModel } from './models/AuthAccessModel';

export default class AuthService {
  authApi: AuthApiRepository;

  constructor() {
    this.authApi = new AuthApiRepository();
  }

  // API

  signIn = async (form: SignInForm): Promise<AuthAccessModel> => {
    const dto = Dto.populate(SignInDto, form);
    const { data } = await this.authApi.signIn(dto);

    return modelFactory.create(AuthAccessModel, data.data);
  };
}
